import React, { useEffect, useState } from "react";
import { Card, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import api from "../admin/api/api"; 
import { image_base_url } from "../admin/api/api";
import "./RelatedProducts.scss";

const RelatedProducts = ({ subCategoryId }) => {
  const navigate = useNavigate();
  const [related, setRelated] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Wait until subCategoryId is available
    if (!subCategoryId) return;

    const fetchRelatedProducts = async () => {
      try {
        setLoading(true);

        const response = await api.get(`/public/products/related/${subCategoryId}`
        );

        // Ensure response is array
        setRelated(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error("Error fetching related products:", error);
        setRelated([]);
      } finally {
        setLoading(false);
      }
    };

    fetchRelatedProducts();
  }, [subCategoryId]);

  if (loading) {
    return (
      <div className="mt-5 text-center">
        <Spinner animation="border" />
      </div>
    );
  }

  if (!related || related.length === 0) {
    return <div className="mt-4">No Related Products Found</div>;
  }

  return (
    <div className="mt-5 box-shadow-normal">
      <h4 className="mb-3 pt-3 fw-bold">Related Products</h4>

      <div className="related-slider">
        {related.map((item) => (
          <Card
            key={item.productId}
            className="related-card"
            onClick={() => navigate(`/product/${item.productId}`)}
            style={{ cursor: "pointer" }}
          >
            <Card.Img
              variant="top"
              src={
                item.image
                  ? `${image_base_url}${item.image}`
                  : "/images/no-image.png"
              }
              className="related-img"
            />

            <Card.Body>
              <Card.Title className="related-title">
                {item.productName}
              </Card.Title>
              <div className="fw-bold">₹ {item.price}</div>
            </Card.Body>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default RelatedProducts;